import { createContext, PropsWithChildren, useContext } from 'react';
import { useCronoCall } from './hooks/useCronoCall';

const CronoCallContext = createContext<ReturnType<typeof useCronoCall> | null>(
  null,
);

export const CronoCallProvider = ({ children }: PropsWithChildren) => {
  const callCtx = useCronoCall();
  return (
    <CronoCallContext.Provider value={callCtx}>
      {children}
    </CronoCallContext.Provider>
  );
};

export const useCronoCallContext = () => {
  const ctx = useContext(CronoCallContext);
  if (!ctx)
    throw new Error(
      'useCronoCallContext must be used within CronoCallProvider',
    );
  return ctx;
};
